import { routeCreator } from "../helpers/routing/routeCreator";
import CheckListsHistory from "../pages/checkLists/checkListsHistory";
import CheckListsHistoryNoPdf from "../pages/checkLists/checkListsHistoryNoPdf";
import Home from "../pages/home/home.jsx";
import Login from "../pages/login/login.jsx";
import UserQuestionnaire from "../pages/preview/userQuestionnaire";
import UserQuestionnaireHistory from "../pages/preview/userQuestionnaireHistory";
import CompletedWithinSLA from "../pages/reports/completedWithinSLA";
import Mtbf from "../pages/reports/mtbf";
import Nmpi from "../pages/reports/nmpi";
import AssetCost from "../pages/reports/assetCost";
import RepeatWo from "../pages/reports/repeatWo";
import Aging from "../pages/reports/aging";
import PurchasesOrder from "../pages/reports/purchasesOrder";
import NonCompletedChecklistsIndex from "../pages/checkLists/nonCompletedChecklistsIndex";
import PlannedMaintenance from "../pages/reports/plannedMaintenance";



export const ROUTE_PAGE_LOGIN = routeCreator(Login, '/', 'login', 'Login', 'page.login')
export const ROUTE_PAGE_HOME = routeCreator(Home, '/', 'home', 'page.home', { exact: true })
export const ROUTE_PAGE_CHECK_LISTS_HISTORY = routeCreator(CheckListsHistory, '/check-list-history', 'checkListsHistory', 'page.checklists', { exact: true })
export const ROUTE_PAGE_CHECK_LISTS_HISTORY_NO_PDF = routeCreator(CheckListsHistoryNoPdf, '/check-list-history-no-pdf', 'checkListsHistoryNoPdf', 'page.checklistsNoPdf', { exact: true })

export const ROUTE_PAGE_USER_QUESTIONNAIRE = routeCreator(UserQuestionnaire, '/user-questionnaire', 'userQuestionnaire', 'page.userQuestionnaire', { exact: true })
export const ROUTE_PAGE_USER_QUESTIONNAIRE_HISTORY = routeCreator(UserQuestionnaireHistory, '/user-questionnaire-history', 'userQuestionnaireHistory', 'page.userQuestionnaireHistory', { exact: true })

export const ROUTE_PAGE_COMPLETED_WITHIN_SLA = routeCreator(CompletedWithinSLA, '/completed-sla', 'completedSla', 'page.completedSla', { exact: true })
export const ROUTE_PAGE_PLANNED_MAINTENANCE = routeCreator(PlannedMaintenance, '/planned-maintenance', 'plannedMaintenance', 'page.plannedMaintenance', { exact: true })
export const ROUTE_PAGE_REPEAT_WO = routeCreator(RepeatWo, '/repeat-wo', 'repeatWo', 'page.repeatWo', { exact: true })
export const ROUTE_PAGE_MTBF = routeCreator(Mtbf, '/mtbf', 'mtbf', 'page.mtbf', { exact: true })
export const ROUTE_PAGE_NMPI = routeCreator(Nmpi, '/nmpi', 'nmpi', 'page.nmpi', { exact: true })
export const ROUTE_PAGE_ASSET_COST = routeCreator(AssetCost, '/asset-cost', 'assetCost', 'page.assetCost', { exact: true })
export const ROUTE_PAGE_AGING = routeCreator(Aging, '/aging', 'aging', 'page.aging', { exact: true })
export const ROUTE_PAGE_PURCHASES_ORDER = routeCreator(PurchasesOrder, '/purchases-order', 'purchasesOrder', 'page.purchasesOrder', { exact: true })
export const ROUTE_PAGE_NON_COMPLETED_CHECKLISTS_INDEX = routeCreator(NonCompletedChecklistsIndex, '/non-completed-checklists', 'nonCompletedcheckLists', 'page.checklists', { exact: true })
const router = {
	ROUTE_PAGE_HOME,
	ROUTE_PAGE_CHECK_LISTS_HISTORY,
	ROUTE_PAGE_CHECK_LISTS_HISTORY_NO_PDF,
	ROUTE_PAGE_USER_QUESTIONNAIRE,
	ROUTE_PAGE_USER_QUESTIONNAIRE_HISTORY,
	ROUTE_PAGE_COMPLETED_WITHIN_SLA,
	ROUTE_PAGE_REPEAT_WO,
	ROUTE_PAGE_MTBF,
	ROUTE_PAGE_NMPI,
	ROUTE_PAGE_ASSET_COST,
	ROUTE_PAGE_AGING,
	ROUTE_PAGE_PURCHASES_ORDER,
	ROUTE_PAGE_NON_COMPLETED_CHECKLISTS_INDEX,
	ROUTE_PAGE_PLANNED_MAINTENANCE
}

export default router;